export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9155.5fbf3a73.jpg";